import type { App } from 'vue'
import * as Sentry from '@sentry/vue'
import { env, isDev, isProd } from '@/shared/config'
import { router } from './router'

export function initSentry(app: App) {
  // Skip Sentry initialization in development mode.
  if (isDev) {
    return
  }

  // DSN is required in production; bail out quietly if it's missing so a
  // misconfigured build doesn't crash the app.
  if (!env.VITE_SENTRY_DSN) {
    console.warn('[sentry] VITE_SENTRY_DSN not set — skipping init.')
    return
  }

  Sentry.init({
    app,
    dsn: env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({
        router,
      }),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: isProd ? 0.1 : 1.0,
    // Session Replay
    replaysSessionSampleRate: isProd ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,
    environment: env.MODE,
    // Release version comes from CI (github.sha) or package.json at build time.
    release: env.VITE_APP_VERSION !== '0.0.0' ? env.VITE_APP_VERSION : undefined,
  })
}
